import CampaignApi from '@/api/Campaign'
import { CompoundCampaignModel } from './CompoundCampaign'
import { CampaignSummaryModel } from './CampaignSummary'

export class CampaignRepository {
  static async search(params) {
    try {
      const ret = await CampaignApi.search({
        advertiserId: params.advertiserId,
        includeDeleted: params.includeDeleted,
        insertionOrder: params.insertionOrder,
        campaign: params.campaign,
        keyword: params.keyword,
        menuType: params.menuType,
        campaignStatuses: params.campaignStatuses,
        pageNo: params.pageNo,
        pageSize: params.pageSize,
        sortKey: params.sortKey,
        sortDirection: params.sortDirection,
      })
      const result = {
        ...ret,
        items: ret.items.map(CampaignSummaryModel.assign),
      }
      return result
    } catch (e) {
      console.error(e)
      return []
    }
  }

  static async get(id) {
    try {
      const res = await CampaignApi.get(id)
      return new CompoundCampaignModel(res.item)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async create(data) {
    try {
      const result = await CampaignApi.create(data)
      return new CompoundCampaignModel(result.item)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async update(id, data) {
    try {
      const result = await CampaignApi.update(id, data)
      return new CompoundCampaignModel(result.item)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async changeStatus(id, nextStatus) {
    try {
      const ret = await CampaignApi.changeStatus(id, nextStatus)
      return new CampaignSummaryModel(ret.item)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async delete(id) {
    try {
      await CampaignApi.delete(id)
    } catch (e) {
      console.error(e)
      throw new Error(`キャンペーンの削除ができませんでした`)
    }
  }
}
